module.exports = __webpack_public_path__ + "img/bloemfontein-celtic-fc.82629be8.png";